import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import { Flex, Text } from '@mprolab/uikit'

const StatusBar: React.FC = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  const content = {
    node: <UseAnimations animation={loading} strokeColor={theme.colors.white3} />,
    title: 'qrLoading',
    titleColor: theme.colors.white3
  }

  return (
    <Flex p="8px 16px" background={theme.colors.gray8} borderRadius="58px" alignItems="center">
      {content.node}
      <Text color={content.titleColor} ml="10px">
        {t(`web3Modal.${content.title}`)}
      </Text>
    </Flex>
  )
}

export default StatusBar
